import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { withRouter } from '@/checkout-instore-legacy/utils/withRouter'
import { injectIntl } from 'react-intl'
import { createStructuredSelector } from 'reselect'

import {
  setLoadingStock,
  loadProduct,
  clear,
  loadProductSku,
  updateSku,
  updateStock,
  loadInstallments,
  loadAttachments,
} from '@/checkout-instore-legacy/product/actions'
import {
  clearLogisticsInfoCache,
  stopLoading,
} from '@/checkout-instore-legacy/cart/simulation/actions'
import withOrderFormAndVendor from '@/checkout-instore-legacy/order/withOrderFormAndVendor'

import { ProductPage } from '../components/ProductPage'
import {
  productStoreSelector,
  stockProductSelector,
  isLoadingStockProductSelector,
  installmentsSelector,
  isLoadingInstallmentsSelector,
  attachmentsSelector,
  isLoadingAttachmentsSelector,
} from '../selectors'
import { allowManualPriceSelector } from '@/checkout-instore-legacy/order/selectors'
import {
  isSimulationLoadingSelector,
  shouldSimulationRefreshSelector,
} from '@/checkout-instore-legacy/cart/simulation/selectors'
import { termSearchSelector } from '@/checkout-instore-legacy/search/selectors'
import {
  updateCartAddressWithSimulationAddress,
  loadSkuSimulation,
  simulationRefreshed,
} from '../../cart/simulation/actions'

const mapStateToPropsSelector = createStructuredSelector({
  productStore: productStoreSelector,
  allowManualPrice: allowManualPriceSelector,
  term: termSearchSelector,
  stock: stockProductSelector,
  isLoadingStock: isLoadingStockProductSelector,
  isSimulationLoading: isSimulationLoadingSelector,
  shouldSimulationRefresh: shouldSimulationRefreshSelector,
  installments: installmentsSelector,
  isLoadingInstallments: isLoadingInstallmentsSelector,
  attachments: attachmentsSelector,
  isLoadingAttachments: isLoadingAttachmentsSelector,
})

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      setLoadingStock,
      loadProduct,
      clear,
      loadProductSku,
      updateSku,
      updateStock,
      clearLogisticsInfoCache,
      stopLoading,
      updateCartAddressWithSimulationAddress,
      loadSkuSimulation,
      simulationRefreshed,
      loadInstallments,
      loadAttachments,
    },
    dispatch
  )

export default withRouter(
  withOrderFormAndVendor(
    injectIntl(
      connect(mapStateToPropsSelector, mapDispatchToProps)(ProductPage)
    )
  )
)
